import { getProjectEnvVariables } from '@/shared/projectEnvVariables';

const { envVariables } = getProjectEnvVariables();

export const isChecklistMockEnabled = () => getProjectEnvVariables().envVariables.VITE_ENABLE_CHECKLIST_MOCK === 'true';
export const CHECKLIST_MOCK_ENABLED = isChecklistMockEnabled();

export const isTicketsMockEnabled = () => getProjectEnvVariables().envVariables.VITE_ENABLE_TICKETS_MOCK === 'true';

export const TICKETS_MOCK_ENABLED = isTicketsMockEnabled();

export const SOCIAL_NETWORK_MOCK_ENABLED = envVariables.VITE_ENABLE_SOCIAL_NETWORK_MOCK === 'true';

export const isTrainingsMockEnabled = () => getProjectEnvVariables().envVariables.VITE_ENABLE_TRAININGS_MOCK === 'true';

export const TRAININGS_MOCK_ENABLED = isTrainingsMockEnabled();
